import jQuery from 'jquery';
console.log(" HELLO  ");
const viewMore = document.querySelector('.wp-block-mpkelly-load-more-posts-plugin' );
console.log( viewMore );
if (viewMore) {
	viewMore.addEventListener('click', async (e) => {
		e.preventDefault();

		const queryEl = event.currentTarget.closest('.wp-block-query');
		const postTemplateEl = queryEl.querySelector('.wp-block-post-template');

		if ( queryEl && postTemplateEl ) {
			const attrs = queryEl.dataset.attrs;
			const block = JSON.parse(attrs);
			const maxPages = block.attrs.query.pages || 0;

			const params = new URLSearchParams();
			params.set('action', 'query_render_more_pagination');
			params.set('attrs', queryEl.dataset.attrs );
			params.set('paged', queryEl.dataset.paged );

			const result = await fetch(`${api.ajax_url}?${params.toString()}`);
			if (result.status === 200) {

				const nextPage= Number( queryEl.dataset.paged ) + 1;

				if ( maxPages > 0 && nextPage >= maxPages ) {
					viewMore.parentNode.removeChild(viewMore);
				}

				queryEl.setAttribute('data-paged', String(nextPage));

				const content = await result.text();
				const element = document.createElement('div');
				element.innerHTML = content;
				const posts = element.querySelector( '.wp-block-post-template' );
				if ( posts && posts.children.length ) {
					Array.from(posts.children).forEach((post) => {
						postTemplateEl.appendChild(post.cloneNode(true));
					});
				} else {
					viewMore.parentNode.removeChild(viewMore);
				}
			}
		}
	});
}

// ( function( $ ) {
// 	$( '.view-more-query' ).on( 'click', function( e ) {
// 		e.preventDefault();
//
// 		const self = $( this );
// 		const queryEl = $( this ).closest( '.wp-block-query' );
// 		const postTemplateEl = queryEl.find( '.wp-block-post-template' );
//
// 		if ( queryEl.length && postTemplateEl.length ) {
// 			const block = JSON.parse( queryEl.attr( 'data-attrs' ) );
// 			const maxPages = block.attrs.query.pages || 0;
// 			$.ajax( {
// 				url: my_ajax_object.ajax_url,
// 				dataType: 'json html',
// 				data: {
// 					action: 'query_render_more_pagination',
// 					attrs: queryEl.attr( 'data-attrs' ),
// 					paged: queryEl.attr( 'data-paged' ),
// 				},
// 				complete( xhr ) {
// 					const nextPage = Number( queryEl.attr( 'data-paged' ) ) + 1;
//
// 					if ( maxPages > 0 && nextPage >= maxPages ) {
// 						self.remove();
// 					}
//
// 					queryEl.attr( 'data-paged', nextPage );
//
// 					if ( xhr.responseJSON ) {
// 						console.log( xhr.responseJSON ); // eslint-disable-line
// 					} else {
// 						const htmlEl = $( xhr.responseText );
//
// 						if ( htmlEl.length ) {
// 							const html = htmlEl.find( '.wp-block-post-template' ).html() || '';
//
// 							if ( html.length ) {
// 								postTemplateEl.append( html );
// 								return;
// 							}
// 						}
//
// 						self.remove();
// 					}
// 				},
// 			} );
// 		}
// 	} );
// }( jQuery ) );
